import { SVGProps, Ref, forwardRef } from 'react';

export const TrainFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.995 6.797c-.031 3.59-.46 5.028-2.469 5.57l1.138 3.411.074.222h-1.476l-.343-1.03H5.08L4.738 16H3.262l.074-.222 1.136-3.409c-2.017-.54-2.446-1.978-2.477-5.572zm-3.868 5.798a25 25 0 0 1-2.132.072c-.81 0-1.513-.02-2.123-.071l-.324.973h4.904zM5.732 8a.933.933 0 1 0 .002 1.867A.933.933 0 0 0 5.732 8m4.53 0a.933.933 0 1 0 .002 1.866A.933.933 0 0 0 10.263 8"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.995 0c4.943 0 5.899.7 5.995 5.396H2C2.096.701 3.052 0 7.995 0M5.667 3.5h4.667V2.1H5.667z"
                fill="currentColor"
            />
        </g>
    </svg>
));
TrainFilledSize16Glyph.displayName = 'TrainFilledSize16Glyph';
